import { Button, CircularProgress } from '@material-ui/core'
import { useTheme } from '@material-ui/core/styles'
import useMediaQuery from '@material-ui/core/useMediaQuery'

import {
  buildFeatureSet,
  getCredentials,
  hasRequiredFeatures
} from '../../cache/auth'
import { getTranslate } from '../../localization'
import accommodationPagesRoleManagement from '../../staticRoleManagement/accommodationsRoleManagement'
import useStyles from './styles/AccommodationFooter.styles'

interface AccommodationFooterProps {
  isSubmitting: boolean
  loadingForAccommodation: boolean
}

export const AccommodationFooter: React.FC<AccommodationFooterProps> = ({
  isSubmitting,
  loadingForAccommodation
}) => {
  const classes = useStyles()
  const theme = useTheme()
  const matches = useMediaQuery(theme.breakpoints.down('sm'))

  const credentials = getCredentials()
  const featureSet = buildFeatureSet(credentials)

  const hasAccessToEditAccommodation = hasRequiredFeatures(
    accommodationPagesRoleManagement
      .find(
        (item) => item.route === '/accommodations/:accID/:propertyCode/:page'
      )
      ?.tabs?.find((tabItem) => tabItem.params.page === 'details')?.sections
      ?.EDIT_ACCOMMODATION?.requiredFeatures,
    featureSet
  )

  return (
    <div className={classes.footer}>
      <Button
        disabled={
          isSubmitting ||
          !hasAccessToEditAccommodation ||
          loadingForAccommodation
        }
        data-cy="saveAccommodation"
        type="submit"
        variant="contained"
        color="primary"
        size="medium"
        fullWidth={matches}>
        {getTranslate('Save Accommodation')}
        {loadingForAccommodation && (
          <CircularProgress
            className={classes.circularProgress}
            size={16}
            color="primary"
          />
        )}
      </Button>
    </div>
  )
}
